import { render, staticRenderFns } from "./add.vue?vue&type=template&id=3dc1c055&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=3dc1c055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc1c055",
  null
  
)

export default component.exports